import React, { createContext, useState, useEffect } from "react";

export const AuthContext = createContext(null);

const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState({
    userId: localStorage.getItem("user_id") || null,
    role: localStorage.getItem("role") || null,
    token: localStorage.getItem("token") || null,
  });

  useEffect(() => {
    // Optionally: refresh token flow can be added here
  }, []);

  const login = ({ userId, role, token }) => {
    localStorage.setItem("user_id", userId);
    localStorage.setItem("role", role);
    localStorage.setItem("token", token);
    setAuth({ userId, role, token });
  };

  const logout = () => {
    localStorage.removeItem("user_id");
    localStorage.removeItem("role");
    localStorage.removeItem("token");
    setAuth({ userId: null, role: null, token: null });
    window.location.href = "/"; // adjust
  };

  return (
    <AuthContext.Provider value={{ ...auth, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
